"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switcher = Switcher;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `Switcher` layout component switches its positioning context between a horizontal and a
 * vertical layout at a given, container-based threshold. That is, if the breakpoint is `32rem`, the
 * layout will switch to a vertical configuration when the parent element is less than `32rem` wide.
 */
function Switcher({
  testId,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledSwitcher, _extends({
    "data-testid": testId
  }, props));
}